import { render, staticRenderFns } from "./GrmResetBtn.vue?vue&type=template&id=61c93494&"
import script from "./GrmResetBtn.vue?vue&type=script&lang=js&"
export * from "./GrmResetBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61c93494')) {
      api.createRecord('61c93494', component.options)
    } else {
      api.reload('61c93494', component.options)
    }
    module.hot.accept("./GrmResetBtn.vue?vue&type=template&id=61c93494&", function () {
      api.rerender('61c93494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/button/GrmResetBtn.vue"
export default component.exports